export const ZoneListCardSkeleton: React.FC = () => (
  <div className='animate-pulse relative w-full bg-skeleton border border-skeleton-border rounded-[30px] px-5 py-3'>
    <div className='text-left relative flex items-start justify-start grow gap-[10px] sm:gap-[20px]'>
      <div className='flex flex-col gap-[10px] grow overflow-hidden'>
        <div className=' '>
          <div className='h-[22px] w-[70%] rounded-lg bg-skeleton-hi mb-[5px]' />
        </div>
        <div className='flex items-center justify-start gap-[10px] leading-[1em]'>
          <div className='flex items-center justify-between bg-skeleton-hi w-[50px] h-[24px] rounded-lg' />
          <div className='flex items-center justify-between bg-skeleton-hi w-[50px] h-[24px] rounded-lg' />
        </div>
      </div>
      <div className='bg-skeleton-hi w-[36px] h-[36px] rounded-full flex items-center justify-center' />
    </div>
  </div>
)
